export const downloadFile = async (
  callback: () => Promise<Blob>,
  fileName: string,
  fileType: string
): Promise<void> => {
  return callback().then((data) => {
    const blob = new Blob([data], { type: fileType });
    // Create blob link to download
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode!.removeChild(link);
  });
};
